"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chips = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const molecule_1 = require("./molecule");
const props_1 = require("../common/props");
/**
 * The chips molecule.
 * @category Molecules
 */
class Chips extends molecule_1.Molecule {
    constructor(molecules) {
        super("Chips", molecules);
        this.minWidth = new props_1.PropertyPixel("Chip Min Width", false, this, { defaultValue: 80 });
        this.visibleHeight = new props_1.PropertyNumberSelectable("Visible Height", false, this, [4, 5, 6, 7, 8], 5);
        this.radius = new props_1.PropertyNumberSelectable("Chip Radius", false, this, [0, 1, 2, 3, 4, 5, 6, 7, 8], 2);
        this.horizontalPadding = new props_1.PropertyNumberSelectable("Horizontal Padding", false, this, [1, 2, 3, 4, 5], 2);
        this.text = new props_1.PropertyStringSelectable("Chip Text", false, this, {
            selectables: ["Caption", "Caption Bold"],
            defaultValue: "Caption",
        });
        this.shadow = new props_1.PropertyShadowSelectable("Chip Elevation", false, this, { defaultValue: "Elevation 2" });
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.minWidth.deserialize(obj.minWidth);
        this.visibleHeight.deserialize(obj.visibleHeight);
        this.radius.deserialize(obj.radius);
        this.horizontalPadding.deserialize(obj.horizontalPadding);
        this.text.deserialize(obj.text);
        this.shadow.deserialize(obj.shadow);
    }
    serialize() {
        const obj = {};
        obj.minWidth = this.minWidth.serialize();
        obj.visibleHeight = this.visibleHeight.serialize();
        obj.radius = this.radius.serialize();
        obj.horizontalPadding = this.horizontalPadding.serialize();
        obj.text = this.text.serialize();
        obj.shadow = this.shadow.serialize();
        return obj;
    }
}
exports.Chips = Chips;
